import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('themeId').setType(Number);
schema.prop('unrisdTimelineEntryId').setType(Number);

export default schema;
